import { render, staticRenderFns } from "./Voorwaarden.vue?vue&type=template&id=d94cfab2&"
import script from "./Voorwaarden.vue?vue&type=script&lang=js&"
export * from "./Voorwaarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports